module.exports = __webpack_public_path__ + "img/yyz2.342fdab3.png";